/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionReportCreate } from '../../models/subscription-report-create';

export interface CreateSubscriptionReport$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
  
    /**
     * The subscription report entry create object
     */
    body: SubscriptionReportCreate
}

export function createSubscriptionReport(http: HttpClient, rootUrl: string, params: CreateSubscriptionReport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, createSubscriptionReport.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

createSubscriptionReport.PATH = '/custom/subscriptions/{uid}/reports';
